export const commonsamples_Spanish = [
   
    
   
   
    {
        id:0,
        chatname:"Verificar gramática",
        promptsandresponses:[
            {
             id:1,
             prompt:"Yo estuve allí.",
             response:"Yo estuve allí."
            },
        ]
    },
    {
        id:1,
        chatname:"Extraer palabras clave",
        promptsandresponses:[
            {
             id:1,
             prompt:"Los autos eléctricos han existido durante bastante tiempo, pero solo en los últimos años se han vuelto más populares. Con la creciente preocupación por el medio ambiente y el calentamiento global, muchas personas ahora están considerando los autos eléctricos como una alternativa a los autos tradicionales que funcionan con gasolina. Una de las principales ventajas de los autos eléctricos es que no producen emisiones. Esto significa que no emiten gases dañinos a la atmósfera, lo cual es una buena noticia para nuestro planeta. Además, son mucho más silenciosos que los autos tradicionales, lo que los convierte en una excelente opción para la conducción en la ciudad.",

             response:"Autos eléctricos, medio ambiente, calentamiento global, alternativa, autos que funcionan con gasolina, cero emisiones, gases dañinos, atmósfera, planeta, más silenciosos, conducción en la ciudad."
            },
        ]
    },
    {
        id:2,
        chatname:"Resumen",
        promptsandresponses:[
            {
             id:1,
             prompt:"Los autos eléctricos han existido durante bastante tiempo, pero solo en los últimos años se han vuelto más populares. Con la creciente preocupación por el medio ambiente y el calentamiento global, muchas personas ahora están considerando los autos eléctricos como una alternativa a los autos tradicionales que funcionan con gasolina. Una de las principales ventajas de los autos eléctricos es que no producen emisiones. Esto significa que no emiten gases dañinos a la atmósfera, lo cual es una buena noticia para nuestro planeta. Además, son mucho más silenciosos que los autos tradicionales, lo que los convierte en una excelente opción para la conducción en la ciudad.",

             response:"Los autos eléctricos están ganando popularidad debido a la creciente preocupación por el medio ambiente y el calentamiento global. Producen cero emisiones y son mucho más silenciosos que los autos tradicionales, lo que los convierte en una excelente opción para la conducción en la ciudad."
            },
        ]
    },
    {
        id:3,
        chatname:"Compacto",
        promptsandresponses:[
            {
             id:1,
             prompt:"Los autos eléctricos han existido durante bastante tiempo, pero solo en los últimos años se han vuelto más populares. Con la creciente preocupación por el medio ambiente y el calentamiento global, muchas personas ahora están considerando los autos eléctricos como una alternativa a los autos tradicionales que funcionan con gasolina. Una de las principales ventajas de los autos eléctricos es que no producen emisiones. Esto significa que no emiten gases dañinos a la atmósfera, lo cual es una buena noticia para nuestro planeta. Además, son mucho más silenciosos que los autos tradicionales, lo que los convierte en una excelente opción para la conducción en la ciudad.",

             response:"Los autos eléctricos se han vuelto más populares debido a las preocupaciones ambientales. Producen cero emisiones, lo que los convierte en una excelente opción para la conducción en la ciudad."
            },
        ]
    },
    {
        id:4,
        chatname:"Descripción",
        promptsandresponses:[
            {
             id:1,
             prompt:"bolso de cuero, marrón, por menos de $29",

             response:`El bolso de cuero es un accesorio elegante y funcional que es perfecto para cualquier ocasión. Hecho de cuero marrón de alta calidad, este bolso es duradero y está diseñado para durar. Cuenta con un amplio compartimento principal que puede contener todos tus elementos esenciales, incluyendo tu teléfono, billetera, llaves y más. El bolso tiene un diseño simple pero elegante, con una sola correa para el hombro que facilita su transporte. Es ligero y cómodo, y la correa ajustable garantiza un ajuste perfecto para cualquier tipo de cuerpo.
             Lo mejor de todo es que este bolso de cuero está disponible por menos de $29, lo que lo convierte en una opción asequible para cualquier persona que quiera un bolso de alta calidad sin gastar mucho dinero. Ya sea que estés haciendo mandados, yendo al trabajo o saliendo por la ciudad, este bolso de cuero es el accesorio perfecto para completar tu look.`
            },
        ]
    },
    {
        id:5,
        chatname:"Correo electrónico",
        promptsandresponses:[
            {
             id:1,
             prompt:"Conferencia de padres y maestros, 12:30 miércoles, Remitente: Tom",

             response:`Asunto: Recordatorio - Conferencia de padres y maestros, 12:30 miércoles
             \n\nEstimados padres,\n\nEspero que este correo electrónico les encuentre bien. Solo un recordatorio rápido de que tenemos la conferencia de padres y maestros programada para las 12:30 pm del miércoles. Esta conferencia es una excelente oportunidad para discutir el progreso de su hijo(a) en la escuela y abordar cualquier inquietud o pregunta que puedan tener.\
             \nComo todos saben, la conferencia se llevará a cabo en línea este año y recibirán un enlace para unirse a la conferencia por correo electrónico. Por favor, asegúrense de revisar su correo electrónico antes de que comience la conferencia. Si tienen alguna dificultad técnica, no duden en contactarme y estaré encantado de ayudarles. Espero con ansias reunirme con todos ustedes y discutir el progreso de su hijo(a) en la escuela. Tenemos mucho de qué hablar, así que por favor vengan preparados con cualquier pregunta o inquietud que puedan tener.
             \n\nGracias y nos vemos a todos el miércoles.
             \n\nSaludos cordiales,
             \n\nTom
             `
            },
        ]
    },
    {
        id:6,
        chatname:"Historia",
        promptsandresponses:[
            {
             id:1,
             prompt:"un pájaro, un perro, día soleado",

             response:`Érase una vez en un día soleado, un pájaro estaba posado en una rama de un árbol, cantando una melodiosa canción. El pájaro disfrutaba del cálido sol y del aire fresco. De repente, un perro vino corriendo hacia el árbol, ladrando fuertemente. El pájaro se asustó y voló lejos, pero el perro continuó persiguiéndolo.\nEl pájaro voló tan rápido como pudo, pero el perro fue rápido y determinado. A medida que la persecución continuaba, el pájaro se dio cuenta de que el perro no intentaba hacerle daño, sino jugar. El pájaro aterrizó en una rama cercana, todavía asustado pero curioso. El perro intentó trepar al árbol, pero era demasiado alto para él.\nEl pájaro se dio cuenta de que el perro no era una amenaza y decidió jugar. Comenzó a piar y a revolotear, invitando al perro a jugar. El perro estaba emocionado y movía la cola felizmente. Los dos comenzaron a perseguirse alrededor del árbol, divirtiéndose mucho.
            A medida que pasaba el día, el sol comenzó a ponerse y el pájaro sabía que era hora de irse. Le dijo adiós al perro con un piar y voló lejos. El perro lo observó desaparecer en el horizonte, sintiéndose un poco triste pero también feliz por la diversión que habían compartido.
            Desde ese día, el perro solía venir al árbol, esperando ver al pájaro nuevamente. Aunque nunca volvieron a jugar juntos, el recuerdo de ese día soleado permaneció en el corazón del perro para siempre. Fue un recordatorio de la alegría que proviene de las amistades inesperadas y de la belleza de la naturaleza en un día soleado.`
            },
        ]
    },

    {
        id: 7,
        chatname: "Mejora",
        promptsandresponses: [
          {
            id: 1,
            prompt: "Los automóviles eléctricos están ganando popularidad debido a la creciente preocupación por el medio ambiente y el calentamiento global. No producen emisiones y son mucho más silenciosos que los autos tradicionales, lo que los convierte en una excelente opción para conducir en la ciudad.",
            response: "Los vehículos eléctricos se han vuelto cada vez más populares debido a la creciente preocupación por el medio ambiente y el calentamiento global. Estos vehículos no producen emisiones y funcionan con menos ruido que los autos tradicionales, lo que los convierte en una opción ideal para conducir en la ciudad."
          }
        ]
      }

    

]
